import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API } from '../config';

const TasksComponent = () => {
  const [tasks, setTasks] = useState([]);
  const [completed, setCompleted] = useState(0);
  const [loading, setLoading] = useState(true);
  const [completing, setCompleting] = useState(null);

  useEffect(() => { fetchTasks(); }, []);

  const fetchTasks = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${API}/tasks/`);
      setTasks(res.data.tasks || []);
      setCompleted(res.data.completed || 0);
    } catch (err) { console.error(err); }
    finally { setLoading(false); }
  };

  const handleComplete = async (taskType) => {
    setCompleting(taskType);
    try {
      const res = await axios.post(`${API}/tasks/${taskType}/complete`);
      alert(res.data.message);
      fetchTasks();
    } catch (err) { alert(err.response?.data?.detail || 'Error al completar tarea'); }
    finally { setCompleting(null); }
  };

  const taskIcons = {
    verify_profile: '👤', first_transaction: '💸', create_inventory: '📦',
    explore_domains: '🧭', savings_setup: '🏦', marketplace_sell: '🏷️',
    maintain_activity: '⚡', recharge_resources: '🔋',
    recover_weight: '📉', diversify_balance: '⚖️', explore_buying: '🛒', boost_velocity: '🚀'
  };

  const totalJing = tasks.reduce((sum, t) => sum + (t.reward_jing || 0), 0);

  return (
    <div className="space-y-6" data-testid="tasks-component">
      <div className="text-center">
        <h2 className="text-2xl font-bold text-gray-900">Mis Tareas</h2>
        <p className="text-gray-600">CUAL-TAREAS te sugiere acciones para mantener tu peso economico</p>
        <p className="text-xs text-gray-400 mt-1">Recompensas en Jing (1 CUALcoin = 1,000 Jing)</p>
      </div>

      {/* Stats */}
      <div className="flex justify-center space-x-6">
        <div className="text-center">
          <p className="text-2xl font-bold text-amber-600">{tasks.length}</p>
          <p className="text-xs text-gray-500">Pendientes</p>
        </div>
        <div className="text-center">
          <p className="text-2xl font-bold text-emerald-600">{completed}</p>
          <p className="text-xs text-gray-500">Completadas</p>
        </div>
        <div className="text-center">
          <p className="text-2xl font-bold text-purple-600">{totalJing}</p>
          <p className="text-xs text-gray-500">Jing posibles</p>
        </div>
      </div>

      {loading ? (
        <div className="text-center py-12 text-gray-500">Cargando tareas...</div>
      ) : tasks.length === 0 ? (
        <div className="text-center py-12">
          <p className="text-2xl mb-2">&#127881;</p>
          <p className="text-gray-500 text-lg">Todas las tareas completadas!</p>
          <p className="text-sm text-gray-400 mt-2">Sigue activo para recibir nuevas tareas</p>
        </div>
      ) : (
        <div className="space-y-3">
          {tasks.map((task) => (
            <div key={task.type} className={`bg-white rounded-xl shadow-sm border p-5 hover:shadow-md transition-shadow ${task.category === 'dynamic' ? 'border-blue-200 bg-blue-50/30' : 'border-gray-200'}`} data-testid={`task-${task.type}`}>
              <div className="flex items-center space-x-4">
                <span className="text-3xl">{taskIcons[task.type] || (task.type.startsWith('connect_') ? '🔗' : '📋')}</span>
                <div className="flex-1">
                  <div className="flex items-center gap-2">
                    <h4 className="font-semibold text-gray-900">{task.title}</h4>
                    {task.category === 'dynamic' && <span className="text-xs px-2 py-0.5 bg-blue-100 text-blue-700 rounded-full">Dinamica</span>}
                  </div>
                  <p className="text-sm text-gray-600 mt-0.5">{task.description}</p>
                </div>
                <div className="text-right flex-shrink-0">
                  <p className="text-lg font-bold text-emerald-600">+{task.reward_jing || 0}</p>
                  <p className="text-xs text-gray-500">Jing</p>
                  <p className="text-xs text-gray-400">{task.reward_cualcoin} Cc</p>
                </div>
                <button
                  onClick={() => handleComplete(task.type)}
                  disabled={completing === task.type}
                  data-testid={`complete-${task.type}`}
                  className="px-4 py-2 bg-gradient-to-r from-amber-500 to-orange-500 text-white rounded-lg text-sm font-medium hover:from-amber-600 hover:to-orange-600 disabled:opacity-50 flex-shrink-0"
                >
                  {completing === task.type ? '...' : 'Completar'}
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};


// Inventory Component - Mi Inventario Global


export default TasksComponent;
